;(function($) {
	var $tooltip = $('[data-tooltip]');
	var template = '<div id="{id}" class="tooltip js-tooltip"><div class="tooltip__message">{message}</div></div>';
	var tooltipClass = '.js-tooltip';

	var tooltip = {
		getElement: function (event, create) {
			create = create || false;

			var id = event || '';
			var elementId = '';

			if (typeof event === 'object') {
				var $self = $(event.target);
				id = $self.data('aria-describedby') || '';

				if (create === true) {
					id = 'tooltip-' + Date.now().toString();
				}
			}

			if (create === false && id.length) {
				elementId = '#' + id;
			}

			return {
				element: $(elementId),
				id: id
			};
		},

		position: function ($parent, $target) {
			var offset = $parent.offset();
			var top = offset.top - $target.outerHeight()
			var left = offset.left - $target.outerWidth();

			if (left < 0) {
				left = offset.left;
			}

			top = Math.round(top).toString() + 'px';
			left = Math.round(left).toString() + 'px';

			var position = [left, top].join(', ');
			$target.css({
				'transform': 'translate(' + position + ')'
			});
		},

		create: function (event) {
			var $self = $(event.target);
			var message = $self.attr('data-tooltip') || '';

			if (!message.length) {
				return false;
			}

			// Generate or get an existing tooltip
			var data = tooltip.getElement(event, true);

			if (data.element.length) {
				return data.element;
			}

			// Generate a new tooltip
			var id = data.id;
			var element = template
				.replace('{id}', id)
				.replace('{message}', message);

			// Keep track of the generated tooltip ID
			$self.data('aria-describedby', id);

			// Add tooltip on the page and capture the new target element
			$('body').append(element);
			data = tooltip.getElement(id);

			return data.element;
		},

		show: function (event) {
			var $parent = $(event.target);
			var $target = tooltip.create(event);

			if ($target) {
				tooltip.position($parent, $target);

				$target.addClass('show');
			}
		},

		hide: function (event) {
			var data = tooltip.getElement(event);
			var $target = data.element;

			$target.removeClass('show');
		},

		hideAll: function (event) {
			$(tooltipClass).removeClass('show');
		},

		clear: function (event) {
			if (event.type !== 'touchstart') {
				return false;
			}

			var data = tooltip.getElement(event);
			var id = data.id;
			var $target = data.element;

			if ($target.length) {
				var targetIndex = $target.index();
				var $tooltips = $(tooltipClass);

				$tooltips.each(function (index, element) {
					var $element = $(element);

					if ($element.index() !== targetIndex) {
						$element.removeClass('show');
					}
				});
			}

			if (!id.length) {
				tooltip.hideAll();
			}
		},

		clearStock: function(event, element) {
			var $stockLevel = $('.skuStockLevelHoverable');
			$(element).unbind();

			if ($stockLevel.length > 0) {
				$stockLevel.removeClass('skuStockLevelHoverable u-hoverable');
				$stockLevel.removeAttr('data-tooltip');
			}

			$('.tooltip').hide();
		},

		handleShow: function(event) {
			var $self = $(event.target);

			$self.off('mouseover mouseout touchstart');
			$self.on('mouseover touchstart', tooltip.show);
			$self.on('mouseout', tooltip.hide);
		}
	};

	$tooltip.on('mouseover touchstart', tooltip.show);
	$tooltip.on('mouseout', tooltip.hide);

	$(document).on('touchstart', tooltip.clear);
	$(document).on('tooltip.show', tooltip.handleShow);
	$(document).on('tooltip.clear.stock', tooltip.clearStock);
})(jQuery);
